// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".79fad40e6257c243d450f67e22700e5e854e88f8.chunk.js";
};